module.exports = __webpack_public_path__ + "img/arrow-block-right.2b004889.svg";